import IconAsMaskImage from "../IconAsMaskImage";

function ImageUpload({ pureSvg, className, color }) {
  const svg = (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33301 4.41788L3.76212 7.03692L8.62893 1.79883"
        stroke="#268750"
        strokeWidth="2.1999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
}

export default ImageUpload;
